import React from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';

const ProcessSec = () => {
    return (
        <div className='bg-[#040404] lg:w-[1600px] pb-20  mx-auto'>
            <section class="bg-[#040404] ">
                <div class="px-4 mx-auto overflow-hidden bg-[#040404] sm:px-6 lg:px-8">
                    <div class=" sm:py-16 lg:py-24 2xl:pl-24">
                        <div class="grid items-center lg:w-[1400px] grid-cols-1 gap-y-12 lg:grid-cols-1 lg:gap-x-8 2xl:gap-x-20">
                            <div>
                                <h2 data-aos="flip-up"  data-aos-duration="1500" class="text-3xl text-center font-bold font-serif leading-tight text-white sm:text-4xl lg:text-8xl lg:leading-tight">My work <span className='text-[#C48F56]'>process</span> </h2>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


            <section class="bg-[#040404] mt-20  mx-auto 2xl:bg-[#040404]">
                <div class="4 mx-auto overflow-hidden bg-[#040404] ">
                    <div class="">
                        <div class="grid items-center grid-cols-1  lg:grid-cols-2 lg:gap-x-8 2xl:gap-x-20">
                            <div data-aos="fade-right" class=" w-40% ">
                                <img className='lg:w-[1200px] lg:h-[500px]' src="https://assets.website-files.com/60fb9da121621b5a7f90d9cd/615c7cc16937f16228889b04_maksym-kaharlytskyi-GwAYapqJKoM-unsplash%20(1)-p-1080.jpeg" alt="" />
                            </div>

                            <div className='p-10 w-60%'>
                                <h2 class="text-3xl font-bold leading-tight text-white sm:text-4xl lg:text-8xl lg:leading-tight">01.</h2>
                                <h2 class="text-3xl font-medium leading-tight font-serif mt-10 mb-10 text-white sm:text-4xl lg:text-5xl lg:leading-tight">You select a package and set a date</h2>
                                <p class="mt-4 text-xl text-gray-50">The "You Select a Package and Set a Date" section is where we establish the foundation of our collaboration. By choosing a package and setting a date, we can move forward with planning and preparing for your shoot. I am committed to providing you with a smooth and stress-free experience, and this section is an important part of that process.</p>

                                <div className='divide-y-4 mt-10 text-2xl text-yellow-600'><h2>1st Step</h2></div>
                            </div>


                        </div>
                    </div>
                </div>


                <div class="4 mx-auto mt-20 overflow-hidden  bg-[#040404] ">
                    <div class="">
                        <div class="grid items-center grid-cols-1  lg:grid-cols-2 lg:gap-x-8 2xl:gap-x-20">

                            <div data-aos="fade-left"
                                class=" w-40%  visible lg:hidden sm:visible xl:visible 2xl:visible  ">
                                <img className='lg:w-[1200px] lg:h-[500px]' src="https://assets.website-files.com/60fb9da121621b5a7f90d9cd/615ca7a08e23ef801116e16d_jon-tyson-A-obUh61bKw-unsplash%20(1)-p-1080.jpeg" alt="" />
                            </div>

                            <div className='p-10 w-60%'>
                                <h2 class="text-3xl font-bold leading-tight text-white sm:text-4xl lg:text-8xl lg:leading-tight">02.</h2>
                                <h2 class="text-3xl font-medium leading-tight font-serif mt-10 mb-10 text-white sm:text-4xl lg:text-5xl lg:leading-tight">I take the pictures and prepare your album</h2>
                                <p class="mt-4 text-xl text-gray-50">The "I Take the Pictures and Prepare Your Album" section is where the magic happens. After our shoot, I'll go through the images and select the best ones to prepare your album. My goal is to provide you with a beautiful and timeless album that captures the essence of your event or shoot. With my keen eye for detail and expertise in post-production, I'll ensure that your images are polished and perfect. I'm committed to delivering a product that you will treasure for years to come.</p>

                                <div className='divide-y-4 mt-10 text-2xl text-yellow-600'><h2>2nd Step</h2></div>
                            </div>


                            <div data-aos="fade-left"
                                class=" w-40% hidden lg:block  ">
                                <img className='lg:w-[1200px]  lg:h-[500px]' src="https://assets.website-files.com/60fb9da121621b5a7f90d9cd/615ca7a08e23ef801116e16d_jon-tyson-A-obUh61bKw-unsplash%20(1)-p-1080.jpeg" alt="" />
                            </div>





                        </div>



                    </div>
                </div>



                <div class="4 mx-auto mt-20 overflow-hidden bg-[#040404] ">
                    <div class="">
                        <div class="grid items-center grid-cols-1  lg:grid-cols-2 lg:gap-x-8 2xl:gap-x-20">
                            <div data-aos="fade-right"
                                class=" w-40% ">
                                <img className='lg:w-[1200px] lg:h-[500px]' src="https://assets.website-files.com/60fb9da121621b5a7f90d9cd/615ca7a565f71fb9d4da3983_samsung-memory-TRD0wNN0wI4-unsplash%20(1)-p-1080.jpeg" alt="" />
                            </div>


                            <div className='p-10 w-60%'>
                                <h2 class="text-3xl font-bold leading-tight text-white sm:text-4xl lg:text-8xl lg:leading-tight">03.</h2>
                                <h2 class="text-3xl font-medium leading-tight font-serif mt-10 mb-10 text-white sm:text-4xl lg:text-5xl lg:leading-tight">I send the deliverables to you on time</h2>
                                <p class="mt-4 text-xl text-gray-50">The "I Send the Deliverables to You on Time" section is the final step in our collaboration. Once I've prepared your album or video, I'll send the final deliverables to you on time, so you can relive the moments we captured together. My commitment to timely delivery is an important part of my photography services, and I take pride in providing a seamless experience for my clients. With your deliverables in hand, you can share your memories with loved ones and cherish them for years to come.</p>

                                <div className='divide-y-4 mt-10 text-2xl text-yellow-600'><h2>3rd Step</h2></div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
};

export default ProcessSec;